import { TenantDto } from '@nusign/picflow-backend-types';

export const getTenantActiveStorage = (tenant: TenantDto, useNew: boolean): bigint => {
  if (useNew) {
    return BigInt(tenant.storage_size);
  }
  return BigInt(tenant.active_storage);
};
